import React from 'react';
import { Badge } from 'react-bootstrap';

type Props = {
  className?: string;
  title?: string;
  'aria-label'?: string;
};

const RequiredBadge: React.FC<Props> = ({
  className,
  title = 'Required',
  'aria-label': ariaLabel = 'Required',
}) => (
  <Badge
    bg="transparent"
    className={`border border-danger text-danger fw-normal flex-shrink-0${className ? ` ${className}` : ''}`}
    title={title}
    aria-label={ariaLabel}
  >
    Required
  </Badge>
);

export default RequiredBadge;
